import axios from 'axios';
import type { AxiosError } from 'axios';
import queryString from 'query-string';

export const axiosInstance = axios.create({
  paramsSerializer: {
    serialize: (params) => queryString.stringify(params, { arrayFormat: 'none' })
  }
});

const getRequestIdFromHeaders = (headers?: Record<string, unknown>): string | undefined => {
  if (!headers) return undefined;

  return (
    (headers['x-requestid'] as string) ||
    (headers['x-request-id'] as string) ||
    (headers['request-id'] as string)
  );
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const requestId = getRequestIdFromHeaders(error.response?.headers);
    if (requestId) {
      (error as AxiosError & { requestId?: string }).requestId = requestId;
    }

    return Promise.reject(error);
  }
);
